export function generateIdS4() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
}

export function generateUniqueId() {
    return `${generateIdS4()}${generateIdS4()}-${generateIdS4()}${generateIdS4()}-${generateIdS4()}${generateIdS4()}-${generateIdS4()}${generateIdS4()}`
}

export function fallbackCopyTextToClipboard(text: string) {
    let textArea = document.createElement('textarea')
    textArea.value = text

    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
        document.execCommand('copy')
        document.body.removeChild(textArea)
        return true
    } catch (err) {
        document.body.removeChild(textArea)
        return false
    }
}

export const debounce = (func: (...args: any) => void) => {
    let timer: any
    return function (this: unknown, ...args: any) {
        const context = this
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
            timer = null
            func.apply(context, args)
        }, 500)
    }
}

export function isOver14Days(lastPlayedArticleTimestamp: number) {
    const currentTime = new Date().getTime()
    const diff = currentTime - lastPlayedArticleTimestamp
    const days14InMs = 14 * 24 * 60 * 60 * 1000
    if (diff > days14InMs) return true
    return false
}
